import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import NotFound from "@/pages/NotFound";
import { Route, Switch } from "wouter";
import ErrorBoundary from "./components/ErrorBoundary";
import { ThemeProvider } from "./contexts/ThemeContext";
import { lazy, Suspense } from "react";

// Lazy load admin page
const LPManager = lazy(() => import('./pages/LPManager'));
import { ProductLandingTemplate } from "./templates/ProductLandingTemplate";
import { downAlternativeConfig } from "./config";
import { btcOfferConfig } from "./config/btc-offer.config";
import { scenarioBConfig } from "./config/scenario-b.config";
import { PricingProvider, SCENARIO_A, SCENARIO_B } from "./contexts/PricingContext";
function Router() {
  return (
    <Switch>
      {/* Homepage - Ryder One Landing Page (Scenario A: $249 → $199, 20% off) */}
      <Route path="/">
        {() => (
          <PricingProvider pricing={SCENARIO_A}>
            <ProductLandingTemplate config={downAlternativeConfig} />
          </PricingProvider>
        )}
      </Route>
      
      {/* Scenario B: $179 → $145 (20% off) */}
      <Route path="/b">
        {() => (
          <PricingProvider pricing={SCENARIO_B}>
            <ProductLandingTemplate config={scenarioBConfig} />
          </PricingProvider>
        )}
      </Route>
      
      {/* BTC Offer Landing Page - $200 Bitcoin Free */}
      <Route path="/btc-offer">
        {() => (
          <PricingProvider pricing={SCENARIO_A}>
            <ProductLandingTemplate config={btcOfferConfig} />
          </PricingProvider>
        )}
      </Route>
      
      {/* Admin Panel */}
      <Route path={"/admin"}>
        {() => <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#2d3a5c]"></div></div>}><LPManager /></Suspense>}
      </Route>
      
      {/* 404 Page */}
      <Route path={"/404"} component={NotFound} />
      <Route component={NotFound} />
    </Switch>
  );
}

// NOTE: About Theme
// - First choose a default theme according to your design style (dark or light bg), than change color palette in index.css
//   to keep consistent foreground/background color across components
// - If you want to make theme switchable, pass `switchable` ThemeProvider and use `useTheme` hook

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider
        defaultTheme="light"
      >
        <TooltipProvider>
          <Toaster />
          <Router />
        </TooltipProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
